import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { resetSuccess } from "../../login/controller/login-slice";
import { useNavigate } from "react-router-dom";
import { STORAGE_KEY } from "../../../constants/constants";
import { resetDashboard } from "../../users/controller/user-slice";
import { Breadcrumb, Container, Row, Spinner } from "reactstrap";
import { getDashboardData } from "../services/dashboard-services";
import CardProject from "./card-dashboard";
import { getPermissionList } from "../../permissions/services/permission-service";
import { DASHBOARD_VIEW_ID } from "../../../helpers/permission/constant-permissions";

export const Dashboard = () => {
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem(STORAGE_KEY.USER));
  const [isLoading, setLoading] = useState(false);

  // Fetch the dashboard data from Redux
  const dashboardDatas = useSelector((state) => state.dashboard.dashboardDatas);
  const loading = useSelector((state) => state.dashboard.loading);

  const dispatch = useDispatch();

  useEffect(() => {
    setLoading(true); // Start loading
    dispatch(getDashboardData({ pageCount: 1, limit: 10, search: "" }))
      .finally(() => setLoading(false));
  }, [dispatch]);

  // Check if the user has the required permission
  const hasPermission = userData?.permission_ids?.includes(DASHBOARD_VIEW_ID);

  if (!hasPermission) {
    return (
      <div className="text-center">
        <h5>You do not have permission to view the dashboard.</h5>
      </div>
    );
  }

  return (
    <>
      <ToastContainer />
      <div className="page-content">
        <div className="d-flex align-items-center text-start">
          <h5 className="mb-0 card-title flex-grow-1">Dashboard</h5>
        </div>
      </div>
      <Container fluid style={{ marginLeft: '12px', marginRight: '12px' }}>
        <Breadcrumb title="dashboard" breadcrumbItem="Dashboard Grid" />
        <Row>
          {loading ? (
            <div className="text-center">
              <Spinner style={{ width: '3rem', height: '3rem' }} color="primary" />
            </div>
          ) : (
            <CardProject dashboard={dashboardDatas} />
          )}
        </Row>
      </Container>
    </>
  );
};
